import {
  Flex,
  Stepper,
  Step,
  StepIndicator,
  StepStatus,
  StepSeparator,
  Text,
  useSteps,
  StepTitle,
  StepDescription,
} from '@chakra-ui/react';
import React from 'react';

import { Icon } from 'packages/common-frontend/components/icons';

type TimelineStepperProps = {
  steps: {
    description?: string;
    icon: string;
    id: string;
    title?: string;
  }[];
  completedStepIndex: number;
};

export const TimelineStepper = ({
  steps,
  completedStepIndex,
}: TimelineStepperProps) => {
  const { activeStep } = useSteps({
    index: completedStepIndex,
    count: steps.length,
  });

  return (
    <Stepper index={activeStep} colorScheme="green" w="100%">
      {steps.map((step) => {
        return (
          <Step key={step.id}>
            <Flex direction="column" gap="0.625rem" alignItems="center">
              <StepIndicator>
                <StepStatus
                  complete={<Icon color="inherit" icon={step.icon} />}
                  incomplete={<Icon color="inherit" icon={step.icon} />}
                  active={<Icon color="green" icon={step.icon} />}
                />
              </StepIndicator>

              <Text as={StepTitle}>{step.title}</Text>
              <Text as={StepDescription}>{step.description}</Text>
            </Flex>

            <StepSeparator />
          </Step>
        );
      })}
    </Stepper>
  );
};
